import { render, staticRenderFns } from "./ChatBoxLocationDetail.vue?vue&type=template&id=66cc3ee9&scoped=true&"
import script from "./ChatBoxLocationDetail.vue?vue&type=script&lang=js&"
export * from "./ChatBoxLocationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxLocationDetail.vue?vue&type=style&index=0&id=66cc3ee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc3ee9",
  null
  
)

export default component.exports